'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var FooterLegal = function FooterLegal() {
  var legalLinks = [{
    label: 'Contact Us',
    link: 'https://www.lanl.gov/resources/contacts.php'
  }, {
    label: 'Terms of Use/Privacy',
    link: 'https://www.lanl.gov/resources/web-policies/copyright-legal.php'
  }, {
    label: 'Site Feedback',
    link: 'https://www.lanl.gov/www-team/forms/wwwgen.php?view=exthome'
  }];
  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: "lanl-ft-legal-col"
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "list-unstyled ft-legal-list"
  }, legalLinks.map(function (_ref) {
    var label = _ref.label,
        link = _ref.link;
    return /*#__PURE__*/React__default['default'].createElement("li", {
      key: label
    }, /*#__PURE__*/React__default['default'].createElement("a", {
      className: "legal-links",
      href: link
    }, label));
  })));
};

exports.FooterLegal = FooterLegal;
exports['default'] = FooterLegal;